import a from"react";var t=function(t){var r=t.children;return a.createElement("div",{className:"vchasno-ui-snackbar-with-action-container"},r)};export{t as default};
//# sourceMappingURL=WithAction.js.map
